import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, FormattedDate, FormattedTime} from 'react-intl';
import {TextareaFieldWithValidation} from '../../../../../common/TextareaFieldWithValidation';
import {
    FORM_FIELD_MESSAGE,
    FORM_FIELD_MESSAGE_OPTION,
    FORM_FIELD_TYPE_OF_REQUEST,
    FORM_LABEL_EDITORS_NOTES_TD,
    FORM_LABEL_MESSAGE,
    FORM_LABEL_MESSAGES_HISTORY,
    FORM_MESSAGES_SECTION,
    FORM_TICKET_SECTION,
} from '../../../../../../constants/formConstants';
import {change, getFormInitialValues, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import get from 'get-value';
import formMessages from '../../../../../../intl/technicalDocumentations/formMessages';
import ValidFormattedMessage from '../../../../../common/ValidFormattedMessage';
import {injectIntl} from 'react-intl';
import commonMessages from '../../../../../../intl/common/commonMessages';
import {parseTextToJSX} from '../../../../../../utils/utils';
import InputSelectFieldWithValidation from "../../../../../common/InputSelectFieldWithValidation";

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const MessagesSectionInternal = props => {
    const {readOnly, initialValues, change, modelAnswers} = props;
    const messages = get(initialValues, 'messages') || [];
    const isDialogBox = !!modelAnswers && modelAnswers.length > 0;

    const handleChange = (e) => {
        if (e.target.value !== '' && e.target.value !== undefined && e.target.value !== null && modelAnswers) {
            const message = modelAnswers.find( answer => answer.uuid === e.target.value );
            change(FORM_FIELD_MESSAGE, get(message, 'text'));
        }
    };

    const getCreatorData = (message) => {
        const {creatorName, solutionGroup, creatorIpn} = message;
        const solutionGroupName = solutionGroup ? ' ' + solutionGroup.name + ' ' : ' ';
        return `${creatorName}${solutionGroupName}(${creatorIpn})`;
    }

    return (
        <>
            {(!readOnly || messages.length > 0) &&
            <>
                <h3 className="text-left mt-4 ml-4">
                    <FormattedMessage {...formMessages.EDITORS_NOTES_SECTION_TD}/>
                </h3>
                <StyledDiv className="border border-secondary bg-white overflow-hidden">
                    {messages.length > 0 &&
                        <div>
                            <div className="border-bottom border-bottom-secondary"
                                 style={{backgroundColor: '#e9ecef', borderRadius: '5px 5px 0 0'}}>
                                <label className="col-form-label pl-0 font-weight-bold ml-3">
                                    <ValidFormattedMessage message={FORM_LABEL_MESSAGES_HISTORY}
                                                           intlMessages={formMessages}/>
                                </label>
                            </div>
                            {messages.map((message, index) =>
                                <div key={index} className="row m-0 align-items-stretch">
                                    <div style={{backgroundColor: '#f8f9fa'}}
                                         className="col-sm-12 col-lg-4 flex-column border-bottom">
                                        <div>
                                            <FormattedDate value={new Date(message.created)}/> <FormattedTime
                                            value={new Date(message.created)}/>
                                            <span className="font-weight-bold">{' '}
                                                <ValidFormattedMessage message={message.isDealer ? 'DEALER' : 'EDITOR'}
                                                                       intlMessages={commonMessages}/>
                                            </span>
                                        </div>
                                        <div>
                                            {getCreatorData(message)}
                                        </div>
                                    </div>
                                    <div className="col border-bottom" style={{whiteSpace: 'pre-wrap'}}>
                                        {parseTextToJSX(message.text)}
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                    {!readOnly &&
                        <div className="col-sm-12 px-4 pb-3 pt-1">
                            {isDialogBox &&
                                <div className="col-xl-4 col-lg-6 col-md-12 px-0 pb-2">
                                    <InputSelectFieldWithValidation
                                        label={formMessages[FORM_LABEL_MESSAGE]}
                                        field={FORM_FIELD_MESSAGE_OPTION}
                                        customOptionsMsg={modelAnswers.map(e => ({
                                            uuid: e.uuid,
                                            presetName: e.subject
                                        }))}
                                        handleChange={handleChange}
                                        boldTooltip
                                    />
                                </div>
                            }
                            <div className="col-sm-12 px-0">
                                <TextareaFieldWithValidation label={!isDialogBox ? formMessages[FORM_LABEL_EDITORS_NOTES_TD] : undefined}
                                                             field={FORM_FIELD_MESSAGE}
                                                             boldTooltip
                                                             rows={3}/>
                            </div>
                        </div>
                    }
                </StyledDiv>
            </>}
        </>
    );
};

const getModelAnswers = (state, schemaType, selectorDocType) => {
    if (!state.solutionGroupInfo || !state.solutionGroupInfo[schemaType]) {
        return undefined;
    }
    const docType = get(state, 'ticket.typeOfRequest') || selectorDocType;
    return get(state, `solutionGroupInfo.${schemaType}`, {default: []}).filter(answer => answer.displayArea === 'INTERNAL_NOTES' && get(answer, 'formTypes', {default: []}).includes(docType));
}

const selector = (form, ...other) => (formValueSelector(form))(...other);
const mapStateToProps = (state, props) => ({
    initialValues: getFormInitialValues(props.form)(state),
    roles: state.profile.userDetail.roles,
    modelAnswers: getModelAnswers(state.techDocInternalTicket, 'modelAnswers', selector(props.form, state, `${FORM_TICKET_SECTION}.${FORM_FIELD_TYPE_OF_REQUEST}`)),
});

const mapDispatchToProps = (dispatch, props) => ({
    change: (name, value) => dispatch(change(props.form, FORM_MESSAGES_SECTION + '.' + name, value)),
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MessagesSectionInternal));
